(function () {
  if (window._saleBannerInitialized) return;
  window._saleBannerInitialized = true;

  function parseTimezoneOffset(offsetStr) {
    // Example: "+0100" => 60 minutes
    const sign = offsetStr.startsWith('-') ? -1 : 1;
    const hours = parseInt(offsetStr.slice(1, 3), 10);
    const minutes = parseInt(offsetStr.slice(3, 5), 10);
    return sign * (hours * 60 + minutes);
  }

  document.querySelectorAll('.saleBanner').forEach(function (banner) {
    const countdownEl = banner.querySelector('.countdown');
    const expiryStr = banner.getAttribute('data-expiry');
    const tzOffsetStr = banner.getAttribute('data-timezone') || '+0000';

    if (!expiryStr || !countdownEl) return;

    const expiryDate = new Date(expiryStr);
    const shopOffsetMins = parseTimezoneOffset(tzOffsetStr);

    function updateCountdown() {
      const now = new Date();
      const localOffsetMins = now.getTimezoneOffset();
      const offsetDiffMs = (shopOffsetMins + localOffsetMins) * 60 * 1000;

      const adjustedNow = new Date(now.getTime() + offsetDiffMs);
      const diff = expiryDate - adjustedNow;

      if (diff <= 0) {
        banner.style.display = 'none';
        clearInterval(timer);
        return;
      }

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);

      countdownEl.textContent = `${d}d : ${h}h : ${m}m : ${s}s`;
    }

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
  });
})();function formatDeliveryDate(deliveryTimeInput, isWeeks) {
    const deliveryTime = deliveryTimeInput.trim();
    
    // Handle weeks mode
    if (isWeeks) {
      if (deliveryTime.includes(',')) {
        // Weeks range format: "4-5 weeks"
        const [minWeeks, maxWeeks] = deliveryTime.split(',').map(w => parseInt(w.trim()));
        if (minWeeks === maxWeeks) {
          return `in ${minWeeks} week${minWeeks !== 1 ? 's' : ''}`;
        }
        return `in ${minWeeks}-${maxWeeks} weeks`;
      } else {
        // Single week format
        const weeks = parseInt(deliveryTime);
        return `in ${weeks} week${weeks !== 1 ? 's' : ''}`;
      }
    }
    
    // Handle days mode (existing logic)
    const today = new Date();
    
    if (deliveryTime.includes(',')) {
      // Date range format - compact format: "16-23 October"
      const [minDays, maxDays] = deliveryTime.split(',').map(d => parseInt(d.trim()));
      const minDate = new Date(today);
      const maxDate = new Date(today);
      minDate.setDate(minDate.getDate() + minDays);
      maxDate.setDate(maxDate.getDate() + maxDays);
      
      const minDay = minDate.getDate();
      const maxDay = maxDate.getDate();
      const month = minDate.toLocaleDateString(undefined, { month: 'long' });
      
      return `by ${minDay}-${maxDay} ${month}`;
    } else {
      // Single date format - full format with weekday
      const singleDate = new Date(today);
      singleDate.setDate(singleDate.getDate() + parseInt(deliveryTime));
      const singleOptions = { weekday: 'long', month: 'long', day: 'numeric' };
      const formatted = singleDate.toLocaleDateString(undefined, singleOptions);
      return `by ${formatted}`;
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Select all delivery date elements
    const pldeliveryDates = document.querySelectorAll(".pl-delivery-date");

    const deliveryTimeInput = "4,5";
    const isWeeks = true;
    const plformatted = formatDeliveryDate(deliveryTimeInput, isWeeks);

    // Loop through all products and update text
    pldeliveryDates.forEach(function (el) {
      el.innerText = plformatted;
    });
  });

 function updateDeliveryDate() {
    const quickCartDeliveryDate = document.getElementById("quickcart-delivery-date");
    if (quickCartDeliveryDate) {
      const deliveryTimeInput = "4,5";
      const isWeeks = true;
      const formatted = formatDeliveryDate(deliveryTimeInput, isWeeks);

      quickCartDeliveryDate.innerText = formatted;
    }
  }

  // Update delivery date when DOM changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if quick cart content was added
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('.quick-cart__item')) {
            updateDeliveryDate();
          }
        });
      }
    });
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also update on initial load (in case the cart already has items)
  document.addEventListener("DOMContentLoaded", updateDeliveryDate);




  document.addEventListener("DOMContentLoaded", function () {
    const deliveryDate = document.getElementById("delivery-date");

    if (deliveryDate) {
      const deliveryTimeInput = "4,5";
      const isWeeks = true;
      const formatted = formatDeliveryDate(deliveryTimeInput, isWeeks);

      deliveryDate.innerText = formatted;
    }
  });